import { Link, useLocation } from "react-router-dom";
import { Home, ShoppingCart, Search } from "lucide-react";

export function MobileTabBar() {
  const loc = useLocation();
  const tabs = [
    { to: "/", label: "ANASAYFA", Icon: Home },
    { to: "/siparis-ver", label: "SİPARİŞ VER", Icon: ShoppingCart, center: true },
    { to: "/siparis-takip", label: "SİPARİŞ TAKİP", Icon: Search },
  ];
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass border-t border-white/10" data-testid="mobile-tabbar">
      <div className="flex items-end justify-around px-4 pt-2 pb-3">
        {tabs.map(({ to, label, Icon, center }) => {
          const active = loc.pathname === to;
          if (center) {
            return (
              <Link key={to} to={to} data-testid={`tab-${to}`} className="flex flex-col items-center -mt-6">
                <span className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center shadow-[0_8px_24px_rgba(216,180,254,0.4)]">
                  <Icon size={24} className="text-[#1f222d]" />
                </span>
                <span className="text-[10px] font-semibold mt-1 text-white">{label}</span>
              </Link>
            );
          }
          return (
            <Link key={to} to={to} data-testid={`tab-${to}`} className="flex flex-col items-center gap-1 py-1">
              <Icon size={22} className={active ? "text-white" : "text-gray-500"} />
              <span className={`text-[10px] font-medium ${active ? "text-white" : "text-gray-500"}`}>{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
